exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-service-update-page .header-tab-options{display:-webkit-box;display:-ms-flexbox;display:flex}.new-service-update-page .header-tab-options .active .button{background-color:#4876ed;color:#fff}.new-service-update-page .header-tab-options .button{border:none;background-color:rgba(0,0,0,0);border-radius:22px;font-family:\"SF Pro Rounded\",sans-serif;color:#3a3a3a;font-weight:bold}", ""]);

// exports
